import React from 'react'
import { hasAccess } from 'utilities/permission'
import {
  MdDashboard,
  MdStorage,
  MdCardGiftcard,
  MdLocalShipping,
  MdSettings,
  MdAssignment,
} from 'react-icons/md'

export const navLinks = (staff) => [
  {
    id: 'dashboard',
    label: 'dashboard.title',
    icon: <MdDashboard />,
    path: '/dashboard',
    show: true,
  },
  {
    id: 'ticket',
    label: 'ticket.title',
    icon: <MdCardGiftcard />,
    items: [
      {
        id: 'buyList',
        label: 'buy.title.list',
        path: '/buy',
        show: hasAccess(staff, 'partBuyTickets'),
      },
      {
        id: 'checkoutList',
        label: 'checkout.title.list',
        path: '/checkout',
        show: hasAccess(staff, 'partCheckoutTickets'),
      },
      {
        id: 'checkinList',
        label: 'checkin.title.list',
        path: '/checkin',
        show: hasAccess(staff, 'partCheckinTickets'),
      },
      {
        id: 'sellList',
        label: 'sell.title.list',
        path: '/sell',
        show: hasAccess(staff, 'partSellTickets'),
      },
      {
        id: 'adjustList',
        label: 'adjust.title.list',
        path: '/adjust',
        show: hasAccess(staff, 'partAdjustTickets'),
      },
      {
        id: 'moveList',
        label: 'move.title.list',
        path: '/move',
        show: hasAccess(staff, 'partMoveTickets'),
      },
    ],
  },
  {
    id: 'inventoryList',
    label: 'inventory.title',
    icon: <MdStorage />,
    items: [
      {
        id: 'inventoryAllList',
        label: 'inventory.title.allList',
        path: '/inventory/all',
        show: hasAccess(staff, 'inventoryPartAllList'),
      },
      {
        id: 'inventoryWarehouseList',
        label: 'inventory.title.warehouseList',
        path: '/inventory/warehouse',
        show: hasAccess(staff, 'inventoryPartList'),
      },
    ],
  },
  {
    id: 'inventoryTechList',
    label: 'inventory.title.techList',
    icon: <MdLocalShipping />,
    path: '/inventory/technician',
    show: hasAccess(staff, 'inventoryPartList'),
  },
  {
    id: 'reportList',
    label: 'report.title.list',
    icon: <MdAssignment />,
    items: [
      {
        id: 'reportStockList',
        label: 'report.title.stockList',
        path: '/report',
        show: hasAccess(staff, 'partReports'),
      },
      {
        id: 'reportRepairList',
        label: 'report.title.repairList',
        path: '/report/repair',
        show: hasAccess(staff, 'partReports'),
      },
    ],
  },
  {
    id: 'setting',
    label: 'setting.title',
    icon: <MdSettings />,
    items: [
      {
        id: 'technicianList',
        label: 'technician.title.list',
        path: '/technician',
        show: true,
      },
      {
        id: 'partList',
        label: 'part.title.list',
        path: '/part',
        show: hasAccess(staff, 'parts'),
      },
      {
        id: 'warehouseList',
        label: 'warehouse.title.list',
        path: '/warehouse',
        show: true,
      },
    ],
  },
]
